import { Roles } from '$synapse/models';
import { Route } from '@angular/router';

import { AuthGuard } from '$synapse/core';
import { GroupAssessmentsResolver } from './group-assessments-resolver';
import { GroupCandidatesResolver } from './group-candidates-resolver';
import { GroupsDetailsComponent } from './group-details.component';

export const GROUPS_DETAILS_ROUTES: Route[] = [
  {
    path: 'groups/:id',
    component: GroupsDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.MANAGER] },
    resolve: {
      candidates: GroupCandidatesResolver,
      assessments: GroupAssessmentsResolver,
    },
    runGuardsAndResolvers: 'always',
  },
];
